var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    width: 28,
    height: 27,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m552.28,905.49c-68.46.04-136.91.33-205.37-.06-42.36-.24-58.45-15.4-58.67-56.94-.53-97.82.14-195.64-.22-293.46-.1-26.97,10.09-44.8,34.42-58.9,73.96-42.86,147.2-87.07,219.18-133.16,21.18-13.56,35.38-12.73,55.08,1.11,62.95,44.22,128.33,85.05,190.05,130.86,15.96,11.84,30.46,36.88,31.06,56.3,3.03,98.94,1.72,198.02.99,297.05-.32,43.22-14.44,56.75-57.49,57.04-69.68.47-139.36.13-209.03.17Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m573.05,199c121.43,82.01,239.67,161.87,361.11,243.88-11.43,20.64-22.2,40.08-34.83,62.88-65.33-43.68-127.94-85.46-190.46-127.39-38.5-25.82-77.81-50.59-114.86-78.36-18.38-13.77-31.12-10.33-48.52.41-110.97,68.56-222.54,136.13-338.09,206.57-11.23-21.57-21.53-41.34-33.45-64.23,133.78-81.71,265.69-162.27,399.1-243.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome01);
export default __webpack_public_path__ + "static/media/home-01.24378934446b0baeab9af254a01c793b.svg";
export { ForwardRef as ReactComponent };